import { ChangeDetectionStrategy, Component, inject, input, ViewEncapsulation } from '@angular/core';
import { ButtonComponent, RootDirective, TooltipDirective } from '@pure/hive';
import { Subject } from 'rxjs';
import {
    EoscFbRenderInfo,
    RECOMMENDATION_ACTION_EVENT_TOKEN,
    RecommendationActionEvent,
} from '../../../../data/models/recommendations.models';
import { registerAsDialogPlugin } from '../../services/recommendation-component-registry.service';
import { EoscRenewButtonComponent } from '../eosc-renewal/eosc-renew-button.component';
import { EoscRenewalNoticeComponent } from '../eosc-renewal/eosc-renewal-notice.component';

/** Stable registry key for this plugin. Used as the lookup name on the corresponding RenderInfo. */
export const EOSC_FB_DIALOG_PLUGIN_NAME = 'EoscFbDialogPluginComponent';

/**
 * Dialog component for the FlashBlade end-of-support-contract (prorec-end-of-support-contract-fb)
 * recommendation.
 *
 * Matches the legacy hardware dialog for an end-of-support contract: the renewal notice, then
 * Dismiss, Cancel and Renew. Footer actions are routed back to the container via
 * {@link RECOMMENDATION_ACTION_EVENT_TOKEN}.
 */
@Component({
    selector: 'eosc-fb-dialog-plugin',
    templateUrl: './eosc-fb-dialog-plugin.component.html',
    styleUrls: ['./eosc-fb-dialog-plugin.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false,
    imports: [ButtonComponent, EoscRenewalNoticeComponent, EoscRenewButtonComponent, RootDirective, TooltipDirective],
    encapsulation: ViewEncapsulation.None,
})
export class EoscFbDialogPluginComponent {
    readonly renderInfo = input.required<EoscFbRenderInfo>();

    protected readonly RecommendationActionEvent = RecommendationActionEvent;

    private readonly recommendationActionEvent$ = inject<Subject<RecommendationActionEvent>>(
        RECOMMENDATION_ACTION_EVENT_TOKEN,
        { optional: true },
    );

    protected handleActionEvent(action: RecommendationActionEvent): void {
        this.recommendationActionEvent$?.next(action);
    }
}

registerAsDialogPlugin(EOSC_FB_DIALOG_PLUGIN_NAME, EoscFbDialogPluginComponent);
